import React, { useState, useEffect } from 'react';
import Toggle from '../../../Common/Toggle/Toggle';
import { FaEdit, FaTrash } from 'react-icons/fa';
import '../Nucleos/Nucleos.css';

import API_BASE_URL from '../../../../config/api';
const InstituicoesFormacao = () => {
  const [instituicoes, setInstituicoes] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [formData, setFormData] = useState({
    instituicao: '',
    ativo: true
  });
  const [loading, setLoading] = useState(false);

  const carregarInstituicoes = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${API_BASE_URL}/instituicoes-formacao`
      );

      if (!response.ok) {
        throw new Error('Erro ao buscar instituições de formação');
      }

      const data = await response.json();

      setInstituicoes(
        data.map((item) => ({
          id: item.id_instituicao,
          instituicao: item.nome_instituicao,
          ativo: item.ativo
        }))
      );
    } catch (error) {
      console.error('Erro ao carregar instituições de formação:', error);
      alert(
        'Erro ao carregar instituições de formação. Verifique a conexão com o servidor.'
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarInstituicoes();
  }, []);

  const filteredInstituicoes = instituicoes.filter((instituicao) =>
    instituicao.instituicao
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      nome_instituicao: formData.instituicao,
      ativo: formData.ativo
    };

    try {
      if (editingId) {
        const response = await fetch(
          `${API_BASE_URL}/instituicoes-formacao/${editingId}`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) {
          throw new Error('Erro ao atualizar instituição de formação');
        }
      } else {
        const response = await fetch(
          `${API_BASE_URL}/instituicoes-formacao`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) {
          throw new Error('Erro ao criar instituição de formação');
        }
      }

      await carregarInstituicoes();
      resetForm();
    } catch (error) {
      console.error('Erro ao salvar instituição de formação:', error);
      alert(
        'Erro ao salvar instituição de formação. Verifique os dados e tente novamente.'
      );
    }
  };

  const handleEdit = (instituicao) => {
    setFormData({
      instituicao: instituicao.instituicao,
      ativo: instituicao.ativo
    });
    setEditingId(instituicao.id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (
      !window.confirm(
        'Tem certeza que deseja excluir esta instituição de formação?'
      )
    ) {
      return;
    }

    try {
      const response = await fetch(
        `${API_BASE_URL}/instituicoes-formacao/${id}`,
        {
          method: 'DELETE'
        }
      );

      if (!response.ok && response.status !== 204) {
        throw new Error('Erro ao excluir instituição de formação');
      }

      await carregarInstituicoes();
    } catch (error) {
      console.error('Erro ao excluir instituição de formação:', error);
      alert(
        'Erro ao excluir instituição de formação. Tente novamente mais tarde.'
      );
    }
  };

  const resetForm = () => {
    setFormData({ instituicao: '', ativo: true });
    setEditingId(null);
    setShowForm(false);
  };

  const handleToggleStatus = async (instituicao) => {
    const novoStatus = !instituicao.ativo;

    try {
      const response = await fetch(
        `${API_BASE_URL}/instituicoes-formacao/${instituicao.id}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            nome_instituicao: instituicao.instituicao,
            ativo: novoStatus
          })
        }
      );

      if (!response.ok) {
        throw new Error('Erro ao atualizar status da instituição');
      }

      setInstituicoes((prev) =>
        prev.map((item) =>
          item.id === instituicao.id ? { ...item, ativo: novoStatus } : item
        )
      );
    } catch (error) {
      console.error('Erro ao atualizar status da instituição:', error);
      alert(
        'Erro ao atualizar status da instituição de formação. Tente novamente.'
      );
    }
  };

  return (
    <div className="tabela-referencia-container">
      <div className="tabela-header">
        <div className="header-content">
          <h1>Instituições de Formação</h1>
        </div>
        {!showForm && (
          <button 
            className="btn-primary"
            onClick={() => setShowForm(true)}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M12 5v14M5 12h14"/>
            </svg>
            Cadastrar Instituição
          </button>
        )}
      </div>

      {showForm ? (
        <div className="form-container inline-form">
          <div className="form-header">
            <h2>{editingId ? 'Editar Instituição de Formação' : 'Cadastrar Instituição de Formação'}</h2>
          </div>
          
          <form onSubmit={handleSubmit} className="form-content">
            <div className="form-group">
              <label htmlFor="instituicao">Instituição *</label>
              <input
                type="text"
                id="instituicao"
                value={formData.instituicao}
                onChange={(e) => setFormData({...formData, instituicao: e.target.value})}
                required
                maxLength={100}
                placeholder="Digite o nome da instituição"
              />
            </div>

            <div className="form-group">
              <Toggle
                id="ativo"
                label="Status:"
                checked={formData.ativo}
                onChange={(e) => setFormData({...formData, ativo: e.target.checked})}
              />
            </div>

            <div className="form-actions">
              <button type="button" className="btn-secondary" onClick={resetForm}>
                Cancelar
              </button>
              <button type="submit" className="btn-primary">
                {editingId ? 'Atualizar' : 'Cadastrar'}
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div className="table-container">
          <div className="table-controls">
            <div className="search-container">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <circle cx="11" cy="11" r="8"/>
                <path d="M21 21l-4.35-4.35"/>
              </svg>
              <input
                type="text"
                placeholder="Pesquisar instituições..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="table-info">
              <span>
                {loading
                  ? 'Carregando instituições de formação...'
                  : `${filteredInstituicoes.length} registro(s) encontrado(s)`}
              </span>
            </div>
          </div>

          <div className="table-wrapper">
            <table className="data-table nucleos-table">
              <thead>
                <tr>
                  <th className="col-id">ID</th>
                  <th className="col-nome">Instituição</th>
                  <th className="col-status">Status</th>
                  <th className="col-acoes">Ações</th>
                </tr>
              </thead>
              <tbody>
                {filteredInstituicoes.map(instituicao => (
                  <tr key={instituicao.id}>
                    <td>{instituicao.id}</td>
                    <td>{instituicao.instituicao}</td>
                    <td className="status-cell">
                      <div className="status-toggle-wrapper">
                        <Toggle
                          checked={instituicao.ativo}
                          onChange={() => handleToggleStatus(instituicao)}
                          id={`toggle-${instituicao.id}`}
                        />
                      </div>
                    </td>
                    <td className="col-acoes">
                      <div className="action-buttons">
                        <button
                          className="btn-edit"
                          onClick={() => handleEdit(instituicao)}
                          title="Editar"
                        >
                          <FaEdit size={16} />
                        </button>
                        <button
                          className="btn-delete"
                          onClick={() => handleDelete(instituicao.id)}
                          title="Excluir"
                        >
                          <FaTrash size={16} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            
            {filteredInstituicoes.length === 0 && (
              <div className="empty-state">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <circle cx="11" cy="11" r="8"/>
                  <path d="M21 21l-4.35-4.35"/>
                </svg>
                <h3>Nenhuma instituição encontrada</h3>
                <p>Tente ajustar os filtros de pesquisa ou cadastre uma nova instituição.</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default InstituicoesFormacao;
